import React from 'react'

const bolt = ({ width = '9', height = '16', className = '' }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 9 16">
    <g
      id="GOOD"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round">
      <g
        id="sidebar-cards"
        transform="translate(-3699.000000, -430.000000)"
        fill="#FFEFBE"
        stroke="#E6B420"
        strokeWidth="0.75">
        <g id="Group-14" transform="translate(3700.000000, 431.000000)">
          <path
            d="M3.56696484,5.74476048 L7.72489136,5.74476048 L0.219201082,16.3480792 L3.08413575,8.00374251 L-0.688214461,8.00374251 L6.06109097,-2.45745637 L3.56696484,5.74476048 Z"
            id="Path-106"
          />
        </g>
      </g>
    </g>
  </svg>
)

export default bolt
